export const messages = {
    saveSuccessfully: "保存成功！",
    importSuccessfully: "导入成功",
    deleteSuccessfully: "删除成功！",
    confirmDelete: "确定要删除吗？",
    scrapSuccessfully: "设备报废成功！",
    noServiceRange: "请选择服务范围！"
}